import React, { useEffect, useState } from "react";
import CartTable2 from "../../../../components/AdminTable/CartTale2";
import axios from "axios";
import { apiKey } from "../../../../config/config";
import MessageCard from "../../../../components/AdminCards/MessageCard";

function RegisterReport() {
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  const columns = [
    {
      header: "SN",
      cell: (row) => row.row.index + 1,
    },

    {
      header: "Opening Date & Time",
      accessorKey: "opening_balance_date_time",
    },
    {
      header: "Opneing Balance",
      accessorKey: "opening_balance",
    },
    {
      header: "All Sales (Paid Amount) ",
      accessorKey: "sub_total_amount",
    },
    {
      header: "Total Vat",
      accessorKey: "total_vat_amount",
    },
    {
      header: "Total return",
      accessorKey: "total_return",
    },
    {
      header: "Total expense",
      accessorKey: "total_expense",
    },
    {
      header: "Customer Due Receive",
      accessorKey: "customer_due_receiv",
    },
    {
      header: "Closing Date & Time",
      accessorKey: "closing_balance_date_time",
    },
    {
      header: "Closing Balance",
      accessorKey: "closing_balance",
    },

    // {
    //   header: "Actions",
    //   accessorKey: "Actions",
    // },
  ];
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [error, setError] = useState(false);
  const [users, setUsers] = useState([]);
  const [data, setData] = useState([]);
  const [selectedUser, setSelectedUser] = useState();

  const handleUserSelect = (e) => {
    setSelectedUser(e.value);
  };

  // const buttonDataa = [
  //   {
  //     buttonText: "Submit",
  //   },
  // ];

  const [selectedOutlet, setSelectedOutlet] = useState();
  const handleOutletSelect = (e) => {
    setSelectedOutlet(e.value);
  };

  const selectButton = [
    {
      placeholder: "User",
      options: users,
      onChange: handleUserSelect,
    },
  ];

  useEffect(() => {
    axios
      .get(`${apiKey}/api/rms/admin/user`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
        params: {
          outletId: user?.user.outlet_id,
        },
      })
      .then((res) => {
        const mappedCustomers = res.data.map((user) => ({
          value: user.id,
          label: user.name,
        }));
        setUsers(mappedCustomers);
        setError(false);
      })
      .catch((err) => {
        setError(err.response.data.message || "Error occured");
      })
      .finally(() => {});
  }, [user?.token, user?.user.outlet_id]);

  useEffect(() => {
    axios
      .get(`${apiKey}/api/rms/admin/shift-report`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
        params: {
          outletId: selectedOutlet || user?.user.outlet_id,
          start_date: startDate,
          end_date: endDate,
          user_id: selectedUser,
        },
      })
      .then((res) => {
        setData(res.data);
        setError(false);
      })
      .catch((err) => {
        setError(err.response.data.message || "Error occured");
      })
      .finally(() => {});
  }, [endDate, selectedOutlet, selectedUser, startDate, user?.token, user?.user.outlet_id]);

  if (error) {
    return <MessageCard error={error} />;
  }

  return (
    <main>
      <CartTable2
        data={data}
        columns={columns}
        heading={"Register Report"}
        // buttonDataa={buttonDataa}
        selectButton={selectButton}
        setStartDate={setStartDate}
        setEndDate={setEndDate}
        downloads={true}
        handleOutletSelect={handleOutletSelect}
      />
    </main>
  );
}

export default RegisterReport;
